export type DrawSize = { width: number; height: number };

export const ZoomScale = 0.6;

export const FontStyle = `
  * {
        font-family: \\"Noto Sans JP\\", sans-serif;
    }
  `;
